import { common as frCommon, jobs as frJobs } from './fr/common';
import { auth as frAuth } from './fr/auth';
import { dashboard as frDashboard } from './fr/dashboard';
import { common as enCommon, jobs as enJobs } from './en/common';
import { auth as enAuth } from './en/auth';
import { dashboard as enDashboard } from './en/dashboard';

export const resources = {
  fr: {
    common: frCommon,
    jobs: frJobs,
    auth: frAuth,
    dashboard: frDashboard
  },
  en: {
    common: enCommon,
    jobs: enJobs,
    auth: enAuth,
    dashboard: enDashboard
  }
};